import script from "./ActionsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsMain.vue?vue&type=script&setup=true&lang=js"

import "./ActionsMain.vue?vue&type=style&index=0&id=e60c0280&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e60c0280"]])

export default __exports__